import React from 'react'
import { Box, Button, Flex, Loading, Message, Text } from '@workwhile/ui'
import { useJetAlertsContextValue } from '../context/JetAlertsProvider'
import { JetAlertsHeader } from './JetAlertsHeader'
import { JetAlertsFilterBar } from './JetAlertsFilterBar'
import { JetAlertsTable } from './JetAlertsTable'

export const JetAlertsMain = () => {
  const {
    state: {
      filters,
      items,
      totalCount,
      pageIndex,
      hasNextPage,
      hasPrevPage,
      isPending,
      isFetching,
      isError,
      error,
    },
    actions: { setFilters, goNextPage, goPrevPage },
  } = useJetAlertsContextValue()

  const hasItems = items.length > 0

  return (
    <>
      <JetAlertsHeader />
      <JetAlertsFilterBar filters={filters} setFilters={setFilters} />
      <Box margin={3}>
        {isPending ? <Loading /> : null}
        {isError && !hasItems ? (
          <Message variant="error" borderRadius="small">
            {error ||
              'Sorry, something went wrong loading JET alerts. Please retry.'}
          </Message>
        ) : null}
        {!isPending && !isError && !hasItems ? (
          <Text color="lightText">No JET alerts found.</Text>
        ) : null}
        {hasItems ? (
          <>
            <Text as="p" fontWeight="bold" mb={2}>
              {`Found ${totalCount} Alert${totalCount === 1 ? '' : 's'}`}
            </Text>
            <JetAlertsTable items={items} />
            {hasPrevPage || hasNextPage ? (
              <Flex mt={3} alignItems="center" justifyContent="center">
                <Button
                  variant="secondary"
                  disabled={!hasPrevPage || isFetching}
                  onClick={goPrevPage}
                >
                  Previous
                </Button>
                <Text mx={3} color="lightText">
                  {`Page ${pageIndex}`}
                </Text>
                <Button
                  variant="secondary"
                  loading={isFetching}
                  disabled={!hasNextPage || isFetching}
                  onClick={goNextPage}
                >
                  Next
                </Button>
              </Flex>
            ) : null}
          </>
        ) : null}
      </Box>
    </>
  )
}
